import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setActive, search } from 'actions/search-actions';
import { hideMiniPlayer } from 'actions/player-actions';
import { getSearchIsActive, getSearchQuery } from 'store/reducers/search';
import { getIsActive } from 'store/reducers/gigyaModal';
import { getPageFromSlug } from 'store/reducers/content';
import { getShowScrollNavigation } from 'store/reducers/navigation';
import Input from './Input';

const mapStateToProps = (state) => ({
  isActive: getSearchIsActive(state),
  query: getSearchQuery(state),
  gigyaIsActive: getIsActive(state),
  page: getPageFromSlug(state, state.content.pageSlug),
  showScrollNavigation: getShowScrollNavigation(state),
});

const mapDispatchToProps = {
  onSetActive: setActive,
  onSearch: search,
  hideMiniPlayer,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Input));
